import { render, staticRenderFns } from "./EFDVATRecords.vue?vue&type=template&id=02e35566&"
import script from "./EFDVATRecords.vue?vue&type=script&lang=js&"
export * from "./EFDVATRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports